// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDRk0Nqwz2qZbrCrqJsIqhqf6x5-iz070I',
    authDomain: 'orderdelivery-c288b.firebaseapp.com',
    databaseURL: 'https://orderdelivery-c288b.firebaseio.com',
    projectId: 'orderdelivery-c288b',
    storageBucket: 'orderdelivery-c288b.appspot.com',
    messagingSenderId: '747464891898'
  }
};
